module.exports = {
  messages: {
    CN: {
      "pagesetting.title": "下单完成页面",
      "pagesetting.title2": "catalog页面",
      "pagesetting.title3": "联系我们页面",
      "pagesetting.title4": "見積依頼",
      'pagesetting.url': '链接',
      'pagesetting.pdfUrl': 'pdf链接',
      'pagesetting.url2': '页面链接',
      'pagesetting.desccontent': '说明内容',
      'pagesetting.addContent': '添加说明内容',
      'pagesetting.editContent': '编辑说明内容',
      'pagesetting.pls': '请输入',
      'pagesetting.pls2': '请输入',
      'pagesetting.pls3': '请输入',
      'pagesetting.addsuccess': '添加成功',
      'pagesetting.editsuccess': '更新成功',
      'pagesetting.deletesuccess': '删除成功',
      'pagesetting.targetEmail': '目标邮箱',
      'pagesetting.replayEmail': '回复邮箱',
      'pagesetting.addreplayEmail': '添加回复邮箱',
      'pagesetting.replayTip': '回复邮箱不能为空',
      'pagesetting.addtargetEmail': '添加目标邮箱',
      'pagesetting.addLink': '添加链接',
      'pagesetting.addLog': '添加catalog',
      'pagesetting.sellerEmail': '担当者群邮箱',
      'pagesetting.editSellerEmailTitle': '编辑担当者群邮箱'
    },
    JP: {
      "pagesetting.title": "注文完了ページ",
      "pagesetting.title2": "カタログページ",
      "pagesetting.title3": "お問い合わせページ",
      "pagesetting.title4": "見積依頼",
      'pagesetting.url': 'リンク',
      'pagesetting.pdfUrl': 'PDFリンク',
      'pagesetting.url2': 'ページリンク',
      'pagesetting.desccontent': '説明内容',
      'pagesetting.addContent': '説明内容を追加',
      'pagesetting.editContent': '説明内容を編集',
      'pagesetting.pls': '入力してください',
      'pagesetting.pls2': '入力してください',
      'pagesetting.pls3': '入力してください',
      'pagesetting.addsuccess': '追加しました',
      'pagesetting.editsuccess': '更新成功',
      'pagesetting.deletesuccess': '削除しました',
      'pagesetting.targetEmail': '送信先のメールアドレス',
      'pagesetting.addtargetEmail': '送信先のメールアドレスを追加',
      'pagesetting.replayEmail': '返信用メールアドレス',
      'pagesetting.addreplayEmail': '返信用メールアドレスを追加',
      'pagesetting.replayTip': '返信用メールアドレスは空にできません',
      'pagesetting.addLink': 'リンクを追加',
      'pagesetting.addLog': '添加catalog',
      'pagesetting.sellerEmail': '担当者グループメール',
      'pagesetting.editSellerEmailTitle': '担当者グループメールを編集'
    }
  }
};